import React, { useState } from 'react';
import { GetAllCrewFiltered_getAllCrewFiltered as Crew } from '../../../types/schemaTypes';
import './CrewItem.scss';
import DeleteModal from '../../../components/JobProfile/DeleteModal';

interface CrewItemProps {
    crew: Crew;
    index: number;
    canEditCrews: boolean;
    onEditClick: (crew: Crew) => void;
    onDelete?: (record: any) => void;
}

const CrewItem = ({ crew, index, onEditClick, onDelete, canEditCrews }: CrewItemProps): React.ReactElement => {
    const { crewNumber, customerName } = crew;
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const isOdd = index % 2 == 1;
    const containerStyle = `CrewsItem-Bottom-Container ${!isOdd && 'CrewsItem-Bottom-Container-With-Background'}`;
    const handleDelete = () => {
        onDelete && onDelete(crew);
        setDeleteConfirm(false);
    };
    return (
        <div className={containerStyle}>
            <div className="CrewsItem-List-Header">{crewNumber}</div>
            <div className="CrewsItem-List-Header">{customerName}</div>
            {!canEditCrews && <div className="GridViewItem-List-Header"></div>}
            {canEditCrews && (
                <div className="GridViewItem-List-Header">
                    {canEditCrews && (
                        <div
                            onClick={() => onEditClick(crew)}
                            className={` ${
                                canEditCrews ? 'GridViewItem-Edit-Container' : 'GridViewItem-Edit-Container-Disable'
                            }`}
                        >
                            <i className="material-icons UsersItem-Icon">edit</i>
                            <span className="UsersItem-Link">Edit</span>
                        </div>
                    )}
                    &nbsp;|&nbsp;
                    {canEditCrews && onDelete && (
                        <div onClick={() => setDeleteConfirm(true)} className={` ${'GridViewItem-Edit-Container'}`}>
                            <i className="material-icons UsersItem-Icon">delete</i>
                            <span className="UsersItem-Link">Delete</span>
                        </div>
                    )}
                </div>
            )}
            {/* <div className="GridViewItem-List-Header">
                <div
                    className={` ${canEditCrews ? 'CrewsItem-Edit-Container' : 'CrewsItem-Edit-Container-Disable'}`}
                    onClick={() => onEditClick(crew)}
                >
                    {' '}
                    {canEditCrews && (
                        <React.Fragment>
                            <i className="material-icons CrewsItem-Icon">edit</i>
                            <span className="CrewsItem-Link">Edit</span>
                        </React.Fragment>
                    )}
                </div>
                &nbsp;|&nbsp;
                <div
                    className={` ${canEditCrews ? 'CrewsItem-Edit-Container' : 'CrewsItem-Edit-Container-Disable'}`}
                    onClick={() => setDeleteConfirm(true)}
                >
                    {' '}
                    {canEditCrews && (
                        <React.Fragment>
                            <i className="material-icons CrewsItem-Icon">delete</i>
                            <span className="CrewsItem-Link">Delete</span>
                        </React.Fragment>
                    )}
                </div>
            </div> */}
            <DeleteModal
                show={deleteConfirm}
                name={'crew'}
                onConfirm={handleDelete}
                onCancel={() => setDeleteConfirm(false)}
            />
        </div>
    );
};

export default CrewItem;

